import {
  auth
} from './firebase';

// Sign Up
export const doCreateUserWithEmailAndPassword = (email, password) =>
  auth.createUserWithEmailAndPassword(email, password);

// Sign In
export const doSignInWithEmailAndPassword = (email, password) =>
  auth.signInWithEmailAndPassword(email, password);

// Sign out
export const doSignOut = () =>
  auth.signOut();

export const onAuthStateChanged = (user) =>
  auth.onAuthStateChanged(user);


// WEBPACK FOOTER //
// ./src/firebase/auth.js